
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MaintenanceService } from '../services/maintenance.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
    constructor(
        private maintenanceService: MaintenanceService,
        private toastr: ToastrService,
        private router: Router
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                // Central redirect when assessment already submitted
                const friendlyMsg = (error?.error?.errors?.[0]?.error || error?.error?.error || '').toString();
                if (friendlyMsg && friendlyMsg.toLowerCase().includes('already has been submitted')) {
                    this.router.navigate(['/candidate/submitted']);
                    return throwError(error);
                }
                // Show maintenance overlay only for explicit maintenance (503) or opt-in header
                const isMaintenance = error.status === 503 || error?.headers?.get('X-Maintenance') === 'true';
                if (isMaintenance) {
                    this.maintenanceService.showMaintenance();
                } else if (error.status >= 500) {
                    const msg = error?.error?.errors?.[0]?.error || 'Something went wrong. Please try again later.';
                    this.toastr.error(msg, 'Server Error', { timeOut: 3000 });
                }
                return throwError(error);
            })
        );
    }
}